import { Injectable } from '@angular/core';
import * as moment from 'moment/moment';

import { ValidationFlag } from './enumtype';
import { HttpClient } from '@angular/common/http';
import { AccessLog, AccessLogSearchData, AccessLogData, ScreenDetail } from './accesslog.model';
import { API_URL, API_Screens } from './apiconfig';
import { Observable } from 'rxjs/Rx';
import { CodeValue } from './index.model';
import { Router } from '@angular/router';

@Injectable()
export class CommonService {

    constructor(private http: HttpClient, private router: Router) { }

    public ScrollToTop() {

        if (document.getElementById("navHeader")) {
            document.getElementById("navHeader").classList.remove('shrink');
            document.getElementById("navHeader").classList.remove('navbar-fixed-top');
            document.getElementById("navHeader").classList.add('navbar-static-top');
        }

        if (document.getElementById("navHeaderUl")) {
            document.getElementById("navHeaderUl").classList.remove('navbar-right');
        }

        if (document.getElementById("divContent")) {
            document.getElementById("divContent").scrollTop = 0;
        }

    }

    public getBetweenDays(fromDate: Date, toDate: Date): number {
        var date1 = new Date(fromDate);
        var date2 = new Date(toDate);
        var timeDiff = Math.abs(date2.getTime() - date1.getTime());
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        return diffDays;
    }

    // Modified by Punithavathy for CRM# 83345 on 06/09/18 to alidate the Phone Number Control
    public phoneNumber(phoneNo: string): boolean {
        if (phoneNo.replace('-', '').replace('-', '').length === 10) {
            return true;
        }
        else {
            return false;
        }
    }

    public extension(Ext: string): boolean {
        return true;
    }

    public isValidDate(validationFlag: number, inputDate: Date, inputToDate?: Date): boolean {

        if (validationFlag === ValidationFlag.IsFutureDate && inputDate) {

            let objDate = new Date(inputDate);
            let inputDay = objDate.getDate();
            let inputMonth = objDate.getMonth();
            let inputYear = objDate.getFullYear();

            let currentDay = moment().toDate().getDate();
            let currentMonth = moment().toDate().getMonth();
            let currentYear = moment().toDate().getFullYear();

            let iDate = new Date(inputYear, inputMonth, inputDay);
            let cDate = new Date(currentYear, currentMonth, currentDay);

            if (iDate > cDate) {
                return true;
            }
            else {
                return false;
            }

        }
        else if (validationFlag === ValidationFlag.IsCurrentOrFutureDate && inputDate) {

            let objDate = new Date(inputDate);

            let currentDay = moment().toDate().getDate();
            let currentMonth = moment().toDate().getMonth();
            let currentYear = moment().toDate().getFullYear();

            let iDate = new Date(this.getYearValue(objDate), this.getMonthValue(objDate), this.getDayValue(objDate));
            let cDate = new Date(currentYear, currentMonth, currentDay);

            if (iDate >= cDate) {
                return true;
            }
            else {
                return false;
            }

        }
        else if (validationFlag === ValidationFlag.IsEqualOrGreaterthan && inputDate && inputToDate) {

            let objDate = new Date(inputDate);
            let objToDate = new Date(inputToDate);

            let iDate = new Date(this.getYearValue(objDate), this.getMonthValue(objDate), this.getDayValue(objDate));
            let toDate = new Date(this.getYearValue(objToDate), this.getMonthValue(objToDate), this.getDayValue(objToDate));

            if (toDate >= iDate) {
                return true;
            }
            else {
                return false;
            }

        }
        else if (validationFlag === ValidationFlag.IsEqualOrLessthan && inputDate && inputToDate) {

            let objDate = new Date(inputDate);
            let objToDate = new Date(inputToDate);

            let iDate = new Date(this.getYearValue(objDate), this.getMonthValue(objDate), this.getDayValue(objDate));
            let toDate = new Date(this.getYearValue(objToDate), this.getMonthValue(objToDate), this.getDayValue(objToDate));

            if (toDate <= iDate) {
                return true;
            }
            else {
                return false;
            }

        }
        else {
            return false;
        }

    }

    public getDayValue(date: Date): number {
        return date.getDate();
    }
    public getMonthValue(date: Date): number {
        return date.getMonth();
    }
    public getYearValue(date: Date): number {
        return date.getFullYear();
    }

    isValidDateFormat(dateString: string, format: string): boolean {

        // format MM/DD/YYYY, DD/MM/YYYY

        return moment(dateString, format, true).isValid()
    }

    get12HourFormat(input: string): string[] {
        var Output = [];

        if (input) {
            var time = input.split(':'); // convert to array

            // fetch
            var hours = Number(time[0]);
            var minutes = Number(time[1]);

            // calculate
            var timeValue;

            if (hours > 0 && hours <= 12) {
                timeValue = "" + hours;
            } else if (hours > 12) {
                timeValue = "" + (hours - 12);
            } else if (hours == 0) {
                timeValue = "12";
            }

            timeValue = Number(timeValue) < 10 ? "0" + timeValue : timeValue;

            timeValue += (minutes < 10) ? ":0" + minutes : ":" + minutes;  // get minutes

            Output[0] = timeValue; // get Time
            Output[1] = (hours >= 12) ? "1" : "0"; // get AM/PM
        }
        else {
            Output[0] = "12:00";
            Output[1] = "0";
        }

        return Output;
    }

    get24hourFormat(input: string): string {
        var dt;
        if (input) {
            dt = moment(input, ["h:mm A"]).format("HH:mm");
        }
        else {
            dt = "12:00"
        }

        return dt;
    }

    logUserAccess(userAccessLog: AccessLog) {
        return this.http.post(API_URL + API_Screens + "/PostAccessLog", userAccessLog);
    }

    getAccessLogDetails(accessLogSearchData: AccessLogSearchData): Observable<AccessLogData[]> {
        return this.http.post<AccessLogData[]>(API_URL + API_Screens + "/GetAccessLogDetails", accessLogSearchData);
    }

    getScreenDetails() {
        return this.http.get<ScreenDetail[]>(API_URL + API_Screens + "/GetScreenDetail");
    }

    cmdRedirect(strPage: String) {
        let link = [strPage];
        this.router.navigate(link);
    }
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/common.service.ts